export function isValidCarNumber(carNumber) {
    let carTest = /\d{2,3}[가-힣]{1}\d{4}/gm;
    return carTest.test(carNumber);
}
export function isValidPhoneNumber(_phoneNumber) {
    let phoneNumber = _phoneNumber.replace(/-/g,"");
    let phoneTest = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/;
    return phoneTest.test(phoneNumber);
}
export function isValidBirthDay(birthDay) {
    if(birthDay.length <= 8) {
        let year = Number(birthDay.substr(0,4));
        let month = Number(birthDay.substr(4,2));
        let day = Number(birthDay.substr(6,2));
        let today = new Date(); // 날짜 변수 선언
        let yearNow = today.getFullYear(); // 올해 연도 가져옴

        // 연도의 경우 1900 보다 작거나 yearNow 보다 크다면 false를 반환합니다.
        if (1900 > year || year > yearNow) {
            return false;
        } else if (month < 1 || month > 12) {
            return false;
        } else if (day < 1 || day > 31) {
            return false;
        } else if ((month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
            return false;
        } else if (month == 2) {
            let isleap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0));
            if (day > 29 || (day == 29 && !isleap)) {
                return false;
            }
        }
        return true;
    } else {
        return false;
    }
}

export default { isValidCarNumber, isValidBirthDay, isValidPhoneNumber  }